import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    width: 100%;
    min-height: 63px;
    align-self: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    padding: 8px;
    box-sizing: border-box;
    background: ${props => props.theme.colours.textWhite};
    color: ${props => props.theme.colours.textCardGreen};
    border-radius: 8px;
    box-shadow: 0px 0px 6px 1px #28282826;
    text-transform: uppercase;
`;

export const WinnerName = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    line-height: 24px;
    color: ${props => props.theme.colours.textCardGreen};
    text-align: center;
`;

export const WinnerLocation = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.normal};
    color: ${props => props.theme.colours.textCardGreen};
    text-align: center;
`;
